import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=29a7641b&scoped=true&"
import script from "./updatePassword.vue?vue&type=script&lang=js&"
export * from "./updatePassword.vue?vue&type=script&lang=js&"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=29a7641b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a7641b",
  null
  
)

export default component.exports